import * as React from "react";

import { Stack, Dialog, Typography, Button, Chip, Box } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import LockIcon from "@mui/icons-material/Lock";
import { Images } from "../../assets/common";
import PrivateAssetRow from "../PrivateAssetRow";
import ApiService from "../../services/api-service";
import NoData from "../Nodata";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AssetPopup({ open, handleClose, id }) {
  const { t } = useTranslation("common");
  const [privateAssets, setPrivateAssets] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const getPrivateAssets = async (id) => {
    try {
      setLoading(true);

      const response = await ApiService.PRIVATE_ASSETS(id);
      setPrivateAssets({ ...response["result"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (id) getPrivateAssets(id);
  }, []);
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            // backgroundColor: "#1E1E1E",
            background: "#171515",
            height: "100vh",
            width: "427px",
            borderRadius: "16px",
            margin: 0,
          },
        }}
      >
        <DialogTitle sx={{ borderBottom: "1px solid #4D4D4D" }}>
          <Stack direction="row" spacing={2}>
            <LockIcon
              sx={{
                color: "#000000",
                backgroundColor: "#FFEE20",
                borderRadius: "50%",
                fontSize: "14px",
                padding: "2px",
              }}
            />
            <Typography color="default">{t("assetPopup.header")}</Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1.5} mt="10px">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="music-content"
                id="music-header"
              >
                <Typography>
                  {t("assetPopup.section1")} (
                  {privateAssets["music"] ? privateAssets["music"].length : 0})
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  {privateAssets && privateAssets["music"] ? (
                    privateAssets["music"].map((music, index) => (
                      <PrivateAssetRow
                        key={index}
                        data={music}
                        type={t("assetPopup.section1")}
                      />
                    ))
                  ) : (
                    <NoData lable={t("noData.noData")} />
                  )}
                </Stack>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="playlist-content"
                id="playlist-header"
              >
                <Typography>
                  {t("assetPopup.section2")} (
                  {privateAssets["playlist"]
                    ? privateAssets["playlist"].length
                    : 0}
                  )
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  {privateAssets && privateAssets["playlist"] ? (
                    privateAssets["playlist"].map((music, index) => (
                      <PrivateAssetRow
                        key={index}
                        data={music}
                        type={t("assetPopup.section2")}
                      />
                    ))
                  ) : (
                    <NoData lable={t("noData.noData")} />
                  )}
                </Stack>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="nftList-content"
                id="nftList-header"
              >
                <Typography>
                  {t("assetPopup.section3")} (
                  {privateAssets["nftList"]
                    ? privateAssets["nftList"].length
                    : 0}
                  )
                </Typography>
              </AccordionSummary>
              {/* <AccordionDetails>
                {privateAssets && privateAssets["nftList"] ? (
                  privateAssets["nftList"].map((music, index) => (
                    <PrivateAssetRow key={index} data={music} type="Nft" />
                  ))
                ) : (
                  <NoData lable={t("noData.noData")} />
                )}
              </AccordionDetails> */}
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="playlistNftList-content"
                id="playlistNftList-header"
              >
                <Typography>
                  {t("assetPopup.section4")} (
                  {privateAssets["playlistNftList"]
                    ? privateAssets["playlistNftList"].length
                    : 0}
                  )
                </Typography>
              </AccordionSummary>
              {/* <AccordionDetails>
                {privateAssets && privateAssets["playlistNftList"] ? (
                  privateAssets["playlistNftList"].map((music, index) => (
                    <PrivateAssetRow
                      key={index}
                      data={music}
                      type="Playlist Nft"
                    />
                  ))
                ) : (
                  <NoData lable={t("noData.noData")} />
                )}
              </AccordionDetails> */}
            </Accordion>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "20px 10px", justifyContent: "center" }}>
          <Button
            sx={{ minWidth: "150px" }}
            color="default"
            onClick={() => handleClose(false)}
          >
            {t("cancel")}
          </Button>
          {/* <Button
            sx={{ minWidth: "150px" }}
            variant="contained"
            color="primary"
            onClick={() => handleClose(true)}
          >
            Subscribe
          </Button> */}
        </DialogActions>
      </Dialog>
      {loading ? <Loader /> : null}
    </div>
  );
}
